/*
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 16:40:01
 * @LastEditTime: 2020-07-20 10:52:48
 */
import Vue from 'vue'
// 第三方组件
import { sync } from 'vuex-router-sync'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
// 文件目录
import views from './views' // 视图
import components from './components' // 全局组件注册入口
import directives from './directives' // 全局指令注册入口
import utils from './utils' // 全局工具注册入口
// http 框架
import Http, { http } from './lib/http'
// 路由
import router from './router'
// 状态管理框架
import store from './store'
// reset css
import 'normalize.css'
import './assets/css/init.css'
import '@/assets/fonts/iconfont.css'
import './assets/css/animiate.css'
import './assets/css/common.css'

// 引入vue-cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import moment from 'moment'
Vue.prototype.$moment = moment

// 入口组件
import App from './components/App/index.vue'

Vue.use(ViewUI)
Vue.use(components)
Vue.use(directives)
Vue.use(utils)
Vue.use(Http)
sync(store, router)

// 自定义列表组件
import Checkbox from './components/checkbox'
import CheckboxGroup from './components/checkboxgroup'
import FiledFilter from './components/alexeistukov-field-filter'
Vue.component('i-checkbox', Checkbox)
Vue.component('i-checkbox-group', CheckboxGroup)
Vue.component('i-filed-filter', FiledFilter)

const app = new Vue({
  router,
  store,
  ...App,
})

Vue.use(views, store, router, http)

export default app
